import React, { useState } from "react";

const contactInfo = [
  {
    id: 1,
    icon: "/email-icon.svg",
    text: "Lorem ipsum dolor sit amet consectetur.",
    type: "email",
  },
  {
    id: 2,
    icon: "/phone-icon.svg",
    text: "+17373076826",
    type: "phone",
  },
  {
    id: 3,
    icon: "/location-icon.svg",
    text: "30 N Gould St. Ste R Sheridan, Wyoming 82801, US.",
    type: "location",
  },
];

export default function Contact() {
  const [isLoading, setIsLoading] = useState(false);
const [submitStatus, setSubmitStatus] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setSubmitStatus(null);

  try {
    const response = await fetch( `${process.env.REACT_APP_API_BASE_URL}/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        phoneNumber: formData.phone,
        message: formData.message,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      setSubmitStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
      setTimeout(() => setSubmitStatus(null), 5000);
    } else {
      setSubmitStatus("error");
      console.error("Error:", data.message);
    }
  } catch (error) {
    setSubmitStatus("error");
    console.error("Network error:", error);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <section className="py:8 sm:py-24 md:px-16 mx-auto bg-light-blue-shade-20">
      <div className="max-w-7xl  mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:items-start item-center">
          {/* Left Side - Contact Info */}
          <div className="space-y-8 xl:space-y-12">
            <div>
              <h2 className="text-4xl 2xl:text-5xl font-gilroy font-extrabold heading-strong text-primary-blue mt-2 mb-16">
                Contact
              </h2>
              <h3 className="text-3xl 2xl:text-4xl font-bold text-gray-900 mb-6">
               Get in Touch With Our Bidzal Team Today.
              </h3>
              <p className="text-gray-600 text-lg 2xl:text-xl leading-relaxed">
              Have questions about Bidzal or need help setting up smart, automated bidding for your freelance projects? Our team is here to guide you, answer your questions, and make sure you get the most value from the platform. Reach out anytime.
              </p>
            </div>

            {/* Contact Details */}
            <div className="space-y-4 xl:space-y-6 2xl:space-y-8 mx-auto">
              {contactInfo.map((item) => (
                <ContactItem key={item.id} item={item} />
              ))}
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <ContactForm
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          submitStatus={submitStatus}
        />
        </div>
      </div>
    </section>
  );
}

function ContactItem({ item }) {
  return (
    <div className="flex items-start gap-4">
      <div className="flex-shrink-0">
        <div className="  w-8 h-8">
          <img src={item.icon} alt={item.type} className="w-full h-full" />
        </div>
      </div>
      <p className="text-gray-700 text-base 2xl:text-xl mt-2">{item.text}</p>
    </div>
  );
}

function ContactForm({ formData, handleChange, handleSubmit, isLoading, submitStatus }) {
  return (
    <div className="bg-white rounded-2xl p-8 w-full max-w-[420px] mx-auto md:ml-auto shadow-[0_20px_70px_rgba(37,99,235,0.18)]">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Name Field */}
        <div>
          <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="i.e. John Doe"
            required
            className="w-full px-4 py-3 border border-primary-blue rounded-lg focus:ring-2 focus:ring-primary-blue focus:border-transparent outline-none transition-all"
          />
        </div>

        {/* Email Field */}
        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="i.e. john@example.com"
            required
            className="w-full px-4 py-3 border border-primary-blue rounded-lg focus:ring-2 focus:ring-primary-blue focus:border-transparent outline-none transition-all"
          />
        </div>

        {/* Phone Field */}
        <div>
          <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">
            Phone Number
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="i.e. +92 312 7885 66"
            required
            className="w-full px-4 py-3 border border-primary-blue rounded-lg focus:ring-2 focus:ring-primary-blue focus:border-transparent outline-none transition-all"
          />
        </div>

        {/* Message Field */}
        <div>
          <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">
            Message
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write your message here"
            rows="3"
            required
            className="w-full px-4 py-3 border border-primary-blue rounded-lg focus:ring-2 focus:ring-primary-blue focus:border-transparent outline-none transition-all resize-none"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-primary-blue text-white font-semibold py-3 px-6 rounded-lg hover:bg-primary-blue/60 transition-colors duration-300"
        >
         {isLoading ? "Sending..." : "Send Message"}
        </button> {/* Success Message */}
        {submitStatus === "success" && (
          <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
            <p className="text-sm font-medium">
              ✓ Message sent successfully! We'll get back to you soon.
            </p>
          </div>
        )}

          {/* Error Message */}
          {submitStatus === "error" && (
            <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
              <p className="text-sm font-medium">
                ✕ Failed to send message. Please try again later.
              </p>
            </div>
          )}

      </form>
    </div>
  );
}
